import { VehicleFiltersData } from "@modules/vehicle/types/vehicleFilter";
import api from "@modules/api/api";

const getVehicleFilterData = async (): Promise<VehicleFiltersData> => {
  return api.get<VehicleFiltersData>("api/vehicles/filter-data");
};

export default getVehicleFilterData;
